<template>
    <app-basket tag="span">
        <template #default="{ totalItems }">
            <span
                :class="{
                    'basket-count': true,
                    'basket-count--big': totalItems > 9,
                    'basket-count--very-big': totalItems > 99,
                }"
            >{{ totalItems }}</span>
        </template>
    </app-basket>
</template>

<script>
import AppBasket from './app-basket';

export default {
    name: 'basket-count',
    components: { AppBasket },
};
</script>
